export default "__VITE_ASSET__BGmT2r8z__"